import React, {Component} from 'react';
import { connect } from 'react-redux';
import { Layout, Spin, Form, Input, Button } from 'antd'
import axios from 'axios';
import qs from 'qs';

import { fetchMenuAction } from '../../store/actions/leftSideMenu';
import { Constant } from '../../config'
import MyModal from '../Modal';
import { updateProfileDetailAction } from '../../store/actions/headerBar';

import './Me.css';

const { Content } = Layout;

class Profile extends Component {
	state = {
		loading: false,
		current_data: {}
	}

	componentWillMount(){
    this.props.fetchMenuAction("", "")
    this.setState({loading: true})
  }

  async componentDidMount() {
    const d = await this._get()
    if (Object.keys(d).length === 0 && d.constructor === Object) {
    	MyModal.error("เกิดข้อผิดพลาด ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง", "", ()=>{
    		window.location.href = "/"
    	})
    	return
    }

    this.setState({
    	loading: false,
    	current_data: {
    		firstname: d.firstname,
	    	lastname: d.lastname,
	    	email: d.email,
    	}
    })
  }

  saveFormRef = formRef => {
    this.formRef = formRef;
  };

  formHandleSubmit = () => {
  	const { form } = this.formRef.props;

    form.validateFields((err, values) => {
    	if (err)
    		return

    	MyModal.confirm("คุณต้องการบันทึกข้อมูล ใช่หรือไม่ ?", "", async (f) => {
    		if (!f)
    			return
    		
    		this.setState({
	        loading: true,
	      })

	      let opt = {
	        url: Constant.ADMIN_API,
	        method: "PUT",
	        data: qs.stringify(values),
	        headers: {
	          'Authorization': "Bearer "+localStorage.getItem(Constant.SessionKey),
	          'Content-Type': 'application/x-www-form-urlencoded'
	        },
	      }
	      let resp
	      let eMsg = `เกิดข้อผิดพลาด ไม่สามารถบันทึกข้อมูลได้ กรุณาลองใหม่อีกครั้ง`
	      let eMsgDetail = ""
	      let eFlag = false

	      try {
	        resp = await axios(opt)
	      } catch(err) {
	        resp = err.response
	      }

	      if (!resp.data) {
	        eFlag = true
	      } else if (resp.data.error) {
	        eFlag = true
	        let e = resp.data.error
	        eMsgDetail = `[${e.code}] ${e.name}`
	      }

	      if (eFlag) {
	        MyModal.error(eMsg, eMsgDetail, ()=>{
	          window.location.reload()
	        })
	      } else {
	        MyModal.info(`บันทึกข้อมูลสำเร็จ`, "", async ()=>{
	          this.setState({
	            loading: false,
	            current_data: values
	          })

	          this.props.updateProfileDetailAction({
							firstname: values.firstname,
							lastname: values.lastname,
							email: values.email,
						})
	        })
	      }

    	}, "ใช่", "ไม่ใช่")
    });
  }

  _get = async () => {
  	let opt = {
  		url: Constant.ADMIN_MY_PROFILE,
  		method: "GET",
      headers: {
        'Authorization': "Bearer "+localStorage.getItem(Constant.SessionKey)
      },
  	}

  	let resp

    try {
      resp = await axios(opt)
    } catch(err) {
      resp = err.response
    }

    if (!resp.data){
      console.log(resp.data)
      return {}
    }

    if (resp.data.error) {
      console.log(resp.data.error)
      return {}
    }

    return resp.data
  }

	render() {
		return (
			<Layout style={{ padding: '0 24px 24px' }}>
        <Spin spinning={this.state.loading} tip="กำลังโหลดข้อมูล...">
          <Content
            style={{
              background: '#fff',
              padding: 24,
              margin: '16px 0',
              minHeight: 300,
            }}
          >
            <h2>ข้อมูลส่วนตัว</h2>
            <ProfileForm 
            	wrappedComponentRef={this.saveFormRef}
            	onCreate={this.formHandleSubmit}
            	data={this.state.current_data}
            />
          </Content>
        </Spin>
      </Layout>
		)
	}
}

const ProfileForm = Form.create({name: "admin_form"})(
	class extends Component {
    componentDidMount(){
    	const { form, data } = this.props
    	form.setFieldsValue(data)
    }

    componentDidUpdate = async (prevProps, prevState) => {
      const {data: pd} = prevProps
      const {data: d, form} = this.props

      if (d && d.email !== pd.email) {
      	form.setFieldsValue(d)
      }
    }

		render() {
			const { form, onCreate } = this.props
			const { getFieldDecorator } = form

			return (
        <Form layout="vertical" className="profile-form" onSubmit={onCreate}>
          {getFieldDecorator('id')(<Input type="hidden" />)}
          <Form.Item label="ชื่อ">
          	{getFieldDecorator('firstname', {
          		rules: [{ required: true, message: "กรุณากรอกชื่อ" }],
          	})(<Input />)}
          </Form.Item>
          <Form.Item label="นามสกุล">
          	{getFieldDecorator('lastname', {
          		rules: [{ required: true, message: "กรุณากรอกนามสกุล" }],
          	})(<Input />)}
          </Form.Item>
          <Form.Item label="อีเมล">
	          {getFieldDecorator('email', {
	            rules: [
	              {
	                type: 'email',
	                message: 'กรุณากรอกอีเมลให้ถูกต้อง เช่น example@mail.com',
	              },
	              {
	                required: true,
	                message: 'กรุณากรอกอีเมล',
	              },
	            ],
	          })(<Input placeholder="เช่น example@mail.com" />)}
	        </Form.Item>
	        
          <div style={{textAlign: 'center'}}>
	        	<Button type="primary" onClick={onCreate}>บันทึก</Button>
          </div>
        </Form>
      )
		}
	}
)

const mapDispatchToProps = dispatch => {
  return {
    fetchMenuAction: (menuParentKey, menuKey) => dispatch(fetchMenuAction(menuParentKey, menuKey)),
    updateProfileDetailAction: ({firstname, lastname, email}) => dispatch(updateProfileDetailAction({firstname, lastname, email})),
  }
}

export default connect(null, mapDispatchToProps)(Profile)


// WEBPACK FOOTER //
// ./src/containers/Me/Profile.js